export interface IState {
  text: string;
  color: string;
}

export function localeMapping(state: String): IState {
  const states = {
    pending: {
      text: 'In Bearbeitung',
      color: 'orange',
    },
    cancelled: {
      text: 'Storniert',
      color: 'red',
    },
    approved: {
      text: 'Akzeptiert',
      color: 'green',
    },
    scheduledForDelivery : {
      text: 'Vorbereitung für den Versand',
      color: 'green',
    },
    deliverySent : {
      text: 'Versandt',
      color: 'green',
    },
    rewardRedeemed : {
      text: 'Eingelöst',
      color: 'green',
    },
    deliveryMissing : {
      text: 'Versand ausstehend',
      color: 'orange',
    },
    markedAsFraud : {
      text: 'Storniert',
      color: 'red',
    },
  };
  const stateName: string = Object.keys(states).filter(st => st === state)[0];
  return states[stateName];
}



// WEBPACK FOOTER //
// ./src/lib/localeMapping.ts